"use client";
import {
  useSelectList
} from "../__chunks/UV2O3GRQ.js";
import "../__chunks/HBGJOTTX.js";
import {
  useSelectProviderContext
} from "../__chunks/5HVNGX6D.js";
import "../__chunks/FHDXHZLB.js";
import "../__chunks/6QXBPV75.js";
import "../__chunks/IB7YUKH5.js";
import "../__chunks/4UUKJZ4V.js";
import {
  usePopover
} from "../__chunks/2WETNHXU.js";
import {
  createDialogComponent
} from "../__chunks/PFM7J2TR.js";
import "../__chunks/57VLL43X.js";
import "../__chunks/CLF4PQ7T.js";
import "../__chunks/BULCTPRV.js";
import "../__chunks/6BJGLK2C.js";
import "../__chunks/CS347UVZ.js";
import "../__chunks/IUB2BTEK.js";
import "../__chunks/XHJGS6Z5.js";
import "../__chunks/TL67WVI6.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/72E5EPFF.js";
import "../__chunks/X6WIMZJE.js";
import "../__chunks/HPP6CWMY.js";
import "../__chunks/UYRJLDVS.js";
import "../__chunks/E3XM3D67.js";
import "../__chunks/CHKJ74UC.js";
import "../__chunks/7452U3HH.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/FSFPRQFR.js";
import "../__chunks/KOKHD3Z3.js";
import "../__chunks/7H5KSHHF.js";
import "../__chunks/G6BJYYBK.js";
import "../__chunks/OAYFXAQ2.js";
import "../__chunks/KK7H3W2B.js";
import "../__chunks/SHA3WOPI.js";
import "../__chunks/BG6HZDS7.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/3ORBWXWF.js";
import "../__chunks/6SB7F42L.js";
import "../__chunks/SMM5JVLC.js";
import "../__chunks/4OZYHFMH.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-popover.ts
var useSelectPopover = createHook(
  (_a) => {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  createComponent((props) => {
    const htmlProps = useSelectPopover(props);
    return createElement("div", htmlProps);
  }),
  useSelectProviderContext
);
if (process.env.NODE_ENV !== "production") {
  SelectPopover.displayName = "SelectPopover";
}
export {
  SelectPopover,
  useSelectPopover
};
